import { AnyAsyncThunk, RejectedActionFromAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
import { PayloadAction, AnyAction } from "@reduxjs/toolkit";

export const getMessageFromResponseError = (error: any) => {
    let message = error?.message;
    const data = error?.response?.data as unknown;
    if (typeof data === 'object' && data !== null) {
        if ('message' in data) {
            message = data.message as string;
        }
        if ('detail' in data) {
            message = data.detail as string;
        }
        if ('error' in data && typeof data.error === 'string') {
            message = data.error;
        }
        if ('errors' in data && Array.isArray(data.errors)) {
            message = data.errors.join(', ');
        }
    }

    return message;
};

export const getErrorMessageFromAction = (
    action: PayloadAction<string | undefined, string> | AnyAction | RejectedActionFromAsyncThunk<AnyAsyncThunk>,
    defaultMessage: string = "Unknown error"
) => {
    let payload = action.payload as unknown;
    if (typeof payload === 'string') {
        return payload;
    }
    if (typeof payload === 'object' && payload !== null) {
        if ('message' in payload) {
            return payload.message as string;
        }
        if ('error' in payload && payload.error instanceof Error) {
            return payload.error.message;
        }
        if ('error' in payload && typeof payload.error === 'string') {
            return payload.error;
        }
    }
    if ('error' in action) {
        if (typeof action.error === 'string') {
            return action.error;
        }
        if (typeof action.error === 'object' && action.error !== null && 'message' in action.error) {
            return action.error.message;
        }
    }
    return defaultMessage;
};
